import styled from 'styled-components'
import colors from '../../tokens/colors'
import typography from '../../tokens/typography'
import layout from '../../tokens/layout'
import border from '../../tokens/border'
import { composeTheme } from '../../utils/compose-theme'
import fonts from '../../tokens/fonts'

export const ProfileIcon = styled.span.attrs((props) => composeTheme(props))`
  align-items: center;
  background: ${(props) => props.theme.brandColors.primaryPure};
  cursor: pointer;
  display: flex;
  height: 3.2rem;
  text-align: center;
  width: 3.2rem;
  z-index: 1;

  &.circle {
    border-radius: ${border.radius.radiusCircular};
    border: ${border.width.widthThin} solid ${colors.neutralColorHighDark};
  }

  &.square {
    border-radius: ${border.radius.radiusSm};
    border: ${border.width.widthThin} solid ${colors.neutralColorHighDark};
  }

  span {
    text-transform: uppercase;
    font-family: ${fonts.inter};
    color: ${colors.neutralColorHighPure};
    padding: 0.5rem;
    font-weight: ${typography.fontWeight.fontWeightBold};
    width: -webkit-fill-available;
    width: -moz-available;

    &:hover {
      color: ${(props) => props.theme.brandColors.primaryPure};
    }
  }

  &:hover {
    color: ${(props) => props.theme.brandColors.primaryPure};
    background: ${(props) => props.theme.brandColors.primaryDark};
  }
`

export const AvatarPicture = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  border: ${border.width.widthThin} solid ${colors.neutralColorHighDark};
  border-radius: ${border.radius.radiusCircular};
`

export const AvatarContainer = styled.div``

export const Wrapper = styled.div`
  display: flex;

  div:not(:first-child) {
    margin-left: -${layout.margin.spacingXxxs};
    z-index: auto;
    > span {
      text-align: center;
    }
  }
  img:last-child {
    z-index: auto;
  }
`

export const Picture = styled.img.attrs((props) => composeTheme(props))`
  width: 3.2rem;
  height: 3.2rem;
  z-index: 1;
  cursor: pointer;
  object-fit: cover;

  &:hover {
    color: ${(props) => props.theme.brandColors.primaryPure};
    background: ${(props) => props.theme.brandColors.primaryDark};
  }

  &.circle {
    border-radius: ${border.radius.radiusCircular};
    border: ${border.width.widthThin} solid ${colors.neutralColorHighDark};
  }

  &.square {
    border-radius: ${border.radius.radiusSm};
    border: ${border.width.widthThin} solid ${colors.neutralColorHighDark};
  }
`
